import { createSlice } from "@reduxjs/toolkit";
import { getAllSubscriptionUsers } from "./action";
const initialState = {
  subscription: {
    list: null,
    loading: false,
    usersDetails: null,
  },
};

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllSubscriptionUsers.pending, (state) => {
      state.subscription.loading = true;
    });
    builder.addCase(getAllSubscriptionUsers.fulfilled, (state, action) => {
      state.subscription.loading = false;
      state.subscription.list = action.payload;
    });
    builder.addCase(getAllSubscriptionUsers.rejected, (state) => {
      state.subscription.loading = false;
    });

  },
});

export default subscriptionSlice.reducer;
